import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { IHrAndBenefits } from "../../../../../models/dashboard/staffDashboard";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setApps } from "../../../../../store/slices/master/appSlice";
import { getApps } from "../../../../../action/masters/appActionCreator";
import { IApps } from "../../../../../models/master/apps";
import { baseURL } from "../../../../../constants/commonConstants";

const HrAndBenifitsViewAll = (props: IHrAndBenefits) => {
  const { getAllHrAndBenifits, HrAndBenifits } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getAllHrAndBenifits(pageBlockId.hrAndBenefits, undefined);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
        <div className="widgets">
          <div className="title">
            <h2>All HR And Benefits</h2>
          </div>
          <div className="card-wrap">
            <div className="row">
              {HrAndBenifits?.filter(
                (benifits: IApps) => benifits.displayOrNot
              ).map((benifits: IApps) => (
                <div className="col-lg-4" key={benifits.id}>
                  <div className="btncard">
                    <a href={benifits.url} target="_blank">
                      <img src={baseURL + benifits.image} alt={benifits.name} />
                      <h3>{benifits.name}</h3>
                      <p>{benifits.description}</p>
                      <span>
                        <img src="/assets/images/icon/arrow-right.svg" alt="" />
                      </span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllHrAndBenifits: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    HrAndBenifits: state.app.apps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HrAndBenifitsViewAll);
